import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['checkbox', 'enabledSection', 'disabledSection', 'disableElement']

    // CheckboxToggleController
    // [x] checkbox -> when toggled it shows enabledSection, hides disabledSection, and vice versa

    connect() {
        this.toggle() // Ensure the correct state is set on page load
    }

    toggle() {
        if (this.checkboxTarget.checked) {
            this.enabledSectionTarget.style.display = 'block'

            if (this.hasDisabledSectionTarget) {
                this.disabledSectionTarget.style.display = 'none'
            }

            if (this.hasDisableElementTarget) {
                this.disableElementTargets.forEach((target) => {
                    target.disabled = false
                })
            }
        } else {
            this.enabledSectionTarget.style.display = 'none'

            if (this.hasDisabledSectionTarget) {
                this.disabledSectionTarget.style.display = 'block'
            }

            if (this.hasDisableElementTarget) {
                this.disableElementTargets.forEach((target) => {
                    target.disabled = true
                })
            }
        }
    }
}
